import './becoder-loading.css';

/** Ant Design supplies the size and positioning through its indicator class. */
export function BecoderLoadingIndicator({ className = '' }: { className?: string }) {
  return <span className={`becoder-loading ${className}`} aria-hidden="true">
    <svg viewBox="0 0 40 40" fill="none" focusable="false">
      <circle className="becoder-loading-track" cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.5" />
      <g className="becoder-loading-orbit">
        <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="24 90" />
      </g>
      <g className="becoder-loading-mark">
        <g transform="translate(7 7) scale(0.1015625)"><circle cx="128" cy="128" r="128" fill="#D97837"/><path d="M56 190L188 58 M82 78L102 98 M78 122L44 156 M172 122L214 164 M104 176A55.155 55.155 0 0 0 182 176" fill="none" stroke="#FFFFFF" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round"/></g>
      </g>
    </svg>
  </span>;
}
